import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import search from "../Assets/rider/search.svg";
import "../Style/Pages/Wallet.css";
import { useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api";
import { WalletPageSkeleton, walletPageSkeleton } from "../Component/Skeleton";
const Wallet = () => {
  const [activetab, setActiveTab] = useState("customer");
  const [tpage, setTpage] = useState(4);
  const [page, setPage] = useState(1);

  const [searchText, setSearchText] = useState("");
  const auth = useSelector((state) => state.auth);
  const token = auth.token;

  useEffect(()=>{setPage(1)},[activetab])

  const formatINR = (amount) => {
    if (!amount || amount === 0) return "0";
    return `₹ ${amount.toLocaleString("en-IN")}`;
  };
  const navigate = useNavigate();

  const [walletData, setWalletData] = useState([]);

  console.log(walletData, 'walletDatawalletData')
  const rowsPerPage = 20;

  const leftStart = page * rowsPerPage - 20;
  // const leftEnd = leftStart + rowsPerPage;

  const rightStart = page * rowsPerPage - 10;
  // const rightEnd = rightStart + rowsPerPage;

  // const leftTableData = walletData.slice(leftStart, leftEnd);
  // const rightTableData = walletData.slice(rightStart, rightEnd);
  const leftTableData = walletData.slice(0, 10);
  const rightTableData = walletData.slice(10, 20);

  const navito = activetab === "driver" ? "/admin/driversdata/driver/" : "/admin/customerdata/user/";

  const [loading, setLoading] = useState(false);

  const fetchDetails = async () => {
    try {
      setLoading(true);

      const roleType = activetab === "customer" ? "user" : "driver";

      const res = await getWithTokenAPI(
        token,
        `/wallet/list?search=${searchText}&type=${roleType}&page=${page}&limit=20`
        // `/user/getall?roletype=${roleType}&search=${searchText}&limit=20&page=${page}`,
      );

      const apiUsers = res?.data?.wallets || [];
      const totalPages = res?.data?.pagination.totalPages;

      const formattedData = apiUsers.map((user, index) => ({
        id: activetab === "driver" ? user?.driverId :user?.customerId,
        name: user.name || "No Name",
        phone: user.phoneNumber || "N/A",
        wallet: user.total_wallet_amount || 0,
      }));

      setWalletData(formattedData);
      setTpage(totalPages);
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [activetab, page, searchText]);

  const columns = ["S.No", "Name", "Ph.Number", " Wallet", "S.No", "Name"];
  return (
    <div className="wallet">
      <div className="walletusertype">
        <span
          className={`usertype ${activetab === "customer" && "active"}`}
          onClick={() => setActiveTab("customer")}
        >
          Customer
        </span>

        <span
          className={`usertype ${activetab === "driver" && "active"}`}
          onClick={() => setActiveTab("driver")}
        >
          Driver
        </span>
      </div>
      <div className="riderpagetop" style={{ height: "10vh", zIndex: "10" }}>
        <span className="ridertophead">Payment</span>
        <div className="ridertopfilter">
          <div className="searchbar">
            <img src={search} alt="search" />
            <input
              className="searchinput"
              type="text"
              placeholder="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setPage(1);
              }}
            />
          </div>
        </div>
      </div>
      {loading ? (
        <WalletPageSkeleton />
      ) : (
        <div className="walletBottom">
          <div className="left">
            <table>
              <thead>
                <th>S.No</th>
                <th>Name</th>
                <th>Ph.Number</th>
                <th>Wallet</th>
              </thead>
              <tbody>
                {leftTableData.length > 0 ? (
                  leftTableData.map((row, i) => (
                    <tr key={row.id}>
                      <td>{leftStart + i + 1}</td>
                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() => navigate(navito + row.id)}
                      >
                        {row.name}
                      </td>
                      <td>{row.phone}</td>
                      <td className="walletbox">
                        {formatINR(row.wallet)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No more records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="right">
            <table>
              <thead>
                <th>S.No</th>
                <th>Name</th>
                <th>Ph.Number</th>
                <th>Wallet</th>
              </thead>
              <tbody>
                {rightTableData.length > 0 ? (
                  rightTableData.map((row, i) => (
                    <tr key={row.id}>
                      <td>{rightStart + i + 1}</td>
                      <td
                        style={{ fontWeight: "500", cursor: "pointer" }}
                        onClick={() => navigate(navito + row.id)}

                      >
                        {row.name}
                      </td>
                      <td>{row.phone}</td>
                      <td className="walletbox">
                        {formatINR(row.wallet.balance)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No more records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {tpage > 1 && (
            <div className="walletpagination">
              {page > 1 && (
                <button
                  className="page-btn"
                  onClick={() => setPage((page) => page - 1)}
                >
                  ‹
                </button>
              )}
              {page > 1 && (
                <button className="page-btn" onClick={() => setPage(1)}>
                  1
                </button>
              )}
              {page === tpage && <span className="page-dots">…</span>}
              <button className="page-btn pgnoactive">{page}</button>

              {page !== tpage && <span className="page-dots">…</span>}

              {page !== tpage && (
                <button className="page-btn" onClick={() => setPage(tpage)}>
                  {tpage}
                </button>
              )}

              {page < tpage && (
                <button
                  className="page-btn"
                  onClick={() => setPage((page) => page + 1)}
                >
                  ›
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Wallet;
